import { render } from "./TopBrandPost.vue?vue&type=template&id=3f5892c6"
import script from "./TopBrandPost.vue?vue&type=script&lang=js"
export * from "./TopBrandPost.vue?vue&type=script&lang=js"

import "./TopBrandPost.vue?vue&type=style&index=0&id=3f5892c6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__